import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { format } from 'date-fns';
import React, { FunctionComponent } from 'react';

import { Milestone } from '../../apollo/__generated__/graphql';
import Typography from './HomeTypography';

interface MilestoneItemProps {
  milestone: Milestone;
}

export const MilestoneItem: FunctionComponent<MilestoneItemProps> = ({
  milestone,
}) => {
  return (
    <Grid item xs={12} md={4}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mx: 5,
          minWidth: 200,
        }}
      >
        <Box
          sx={{
            fontSize: 24,
            fontFamily: 'default',
          }}
        >
          {milestone.name}
        </Box>
        {milestone.prices.length > 1 ? (
          [...milestone.prices].reverse().map((price) => (
            <Typography
              key={price.day}
              variant="h4"
              align="center"
              color="primary"
              fontWeight="medium"
            >
              {price.day + 1} soir{price.day + 1 === 1 ? '' : 's'} :{' '}
              {price.value / 100}€
            </Typography>
          ))
        ) : (
          <Typography
            variant="h3"
            align="center"
            color="primary"
            fontWeight="medium"
          >
            {milestone.prices[0].value / 100}€
          </Typography>
        )}
        {(milestone.bedroomValue ?? 0) > 0 ? (
          <Typography variant="subtitle2" align="center">
            Supplément chambre :{' '}
            <Typography
              variant="inherit"
              component="span"
              color="primary"
              fontWeight="medium"
            >
              +{(milestone.bedroomValue ?? 0) / 100}€
            </Typography>
          </Typography>
        ) : null}
        {(milestone.noAlcoholDiscount ?? 0) > 0 ? (
          <Typography variant="subtitle2" align="center">
            Réduction BT :{' '}
            <Typography
              variant="inherit"
              component="span"
              color="primary"
              fontWeight="medium"
            >
              -{(milestone.noAlcoholDiscount ?? 0) / 100}€
            </Typography>
          </Typography>
        ) : null}
        <Typography variant="body2" align="center">
          Du{' '}
          <Typography
            variant="inherit"
            component="span"
            color="primary"
            fontWeight="medium"
          >
            {format(milestone.startAt, 'dd/MM/yyyy')}
          </Typography>{' '}
          au{' '}
          <Typography
            variant="inherit"
            component="span"
            color="primary"
            fontWeight="medium"
          >
            {format(milestone.endAt, 'dd/MM/yyyy')}
          </Typography>
        </Typography>
      </Box>
    </Grid>
  );
};
